import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-play-fill text-xl" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              91av<span className="text-accent-400">视频</span>
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-200">
            91av视频是面向影视爱好者的综合影视视频资源平台，涵盖电影、电视剧、综艺等多种类型，提供内容浏览、
            分类筛选、专题合集与详情介绍服务，帮助你快速找到感兴趣的影视作品。
          </p>
          <p className="mt-4 text-xs text-primary-300">
            本站为内容演示站点，影片信息均为虚构，播放相关按钮仅为演示状态。
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-semibold text-background-50">影视分类</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/category/movie" className="transition-colors hover:text-accent-300">
                电影频道
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="transition-colors hover:text-accent-300">
                电视剧频道
              </Link>
            </li>
            <li>
              <Link to="/category/variety" className="transition-colors hover:text-accent-300">
                综艺频道
              </Link>
            </li>
            <li>
              <Link to="/search?q=科幻" className="transition-colors hover:text-accent-300">
                科幻专题
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-semibold text-background-50">关于我们</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                关于本站
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                联系我们
              </Link>
            </li>
            <li>
              <Link to="/special/sp-03" className="transition-colors hover:text-accent-300">
                专题合集
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                用户反馈
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 md:flex-row md:px-8">
          <span>© 2026 91av视频 · 综合影视视频资源在线观看平台</span>
          <span>本站内容仅用于学习与演示，不提供真实播放服务</span>
        </div>
      </div>
    </footer>
  );
}